import React from 'react'
import cx from 'classnames'
import useEventListener from '@use-it/event-listener'
import styles from './video-section.module.scss'

function useClickOutside({ element, onClick }) {
  useEventListener('click', e => {
    if (!element.current.contains(e.target)) onClick(event)
  })
}

function VideoSection({ details, player, className = undefined, ...props }) {
  const [active, setActive] = React.useState(false)
  const ref = React.useRef()
  useClickOutside({
    element: ref,
    onClick: () => (window.innerWidth >= 768 ? setActive(false) : null),
  })
  return (
    <section {...props} className={cx(styles.overflow, className)}>
      <div className="container container--grid">
        <div
          className={cx(styles.grid, 'container__row', {
            [styles.hideCard]: active,
            [styles.showVideo]: active,
          })}
        >
          <div className={styles.player} ref={ref}>
            {player && player({ active, setActive })}
          </div>
          <div className={styles.details}>
            {details && details({ active, setActive })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default VideoSection
